import { Button, CircularProgress } from '@mui/material';
import React from 'react';

import { pxToRem } from 'components/theme/typography';

type Props = {
    label: string;
    onClick?: () => void;
    isDisabled: boolean;
    isSubmit?: boolean;
    isLoading?: boolean;
};

const AuthButton = ({ label, onClick, isDisabled, isSubmit, isLoading }: Props) => {
    const handleClick = () => {
        if (onClick) onClick();
    };

    return (
        <Button
            variant="contained"
            onClick={handleClick}
            fullWidth
            disabled={isDisabled || isLoading}
            disableRipple
            type={isSubmit ? 'submit' : 'button'}
            sx={{
                py: pxToRem(16),
                fontSize: {
                    xs: pxToRem(16),
                },
                lineHeight: {
                    xs: 1.5,
                },
                backgroundColor: isLoading ? 'grey.light' : 'primary.dark',
                boxShadow: 'none',
                '&:disabled': {
                    bgcolor: '#61A3A9',
                    color: 'common.white',
                    boxShadow: 'none',
                },
                '&:hover, &:focus': {
                    boxShadow: 'none',
                },
                '&:focus-visible': {
                    outline: '1px solid #FFFFFF',
                    outlineOffset: '-3px',
                },
            }}
        >
            {isLoading ? <CircularProgress size={24} /> : label}
        </Button>
    );
};

export default AuthButton;
